module.exports = __webpack_public_path__ + "img/Logo-Era-Tua-Body.ed84361.svg";